/**
 * PLAN-011 Phase 5.1: Feature Flags Redux Slice
 *
 * Stores enabled feature flags for the current user's active role.
 * Fetched on login and on role switch via getUserFeatures().
 *
 * Usage in components:
 *   const features = useSelector((state) => state.features.flags);
 *   if (features.appointment_booking) { ... }
 */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserFeatures } from "../services/admin";

export const fetchFeatures = createAsyncThunk(
  "features/fetchFeatures",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getUserFeatures();
      return data;
    } catch (error) {
      return rejectWithValue({});
    }
  }
);

const featuresSlice = createSlice({
  name: "features",
  initialState: {
    flags: {},
    loaded: false,
  },
  reducers: {
    setFeatures: (state, action) => {
      state.flags = action.payload;
      state.loaded = true;
    },
    clearFeatures: (state) => {
      state.flags = {};
      state.loaded = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFeatures.fulfilled, (state, action) => {
      state.flags = action.payload;
      state.loaded = true;
    });
    builder.addCase(fetchFeatures.rejected, (state) => {
      state.flags = {};
      state.loaded = true;
    });
  },
});

export const { setFeatures, clearFeatures } = featuresSlice.actions;
export default featuresSlice.reducer;
